import React from 'react';
import { FullscreenOverlayProvider } from './FullscreenOverlayContext';
import type { FullscreenOverlayRootProps } from './types';

/**
 * FullscreenOverlayRoot Component
 *
 * Root component that provides context for state management.
 * Must wrap all other FullscreenOverlay sub-components.
 *
 * Supports both controlled and uncontrolled usage patterns:
 * - Controlled: Pass `open` and `onOpenChange` props
 * - Uncontrolled: Pass `defaultOpen` prop (defaults to false)
 *
 * @example Uncontrolled usage
 * <FullscreenOverlay.Root defaultOpen={false}>
 *   <FullscreenOverlay.Trigger>...</FullscreenOverlay.Trigger>
 *   <FullscreenOverlay.Portal>...</FullscreenOverlay.Portal>
 * </FullscreenOverlay.Root>
 *
 * @example Controlled usage
 * <FullscreenOverlay.Root open={isOpen} onOpenChange={setIsOpen}>
 *   <FullscreenOverlay.Trigger>...</FullscreenOverlay.Trigger>
 *   <FullscreenOverlay.Portal>...</FullscreenOverlay.Portal>
 * </FullscreenOverlay.Root>
 */
export const FullscreenOverlayRoot = ({ children, open, defaultOpen, onOpenChange }: FullscreenOverlayRootProps) => {
  return (
    <FullscreenOverlayProvider open={open} defaultOpen={defaultOpen} onOpenChange={onOpenChange}>
      {children}
    </FullscreenOverlayProvider>
  );
};
